var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page-container',{staticClass:"text-grey-8 q-pt-sm",attrs:{"align":"right"}},[_c('q-btn',{attrs:{"color":"primary","icon":"fas fa-chevron-left","label":_vm.$t(_vm.translations.BACK),"flat":""},on:{"click":_vm.goBack}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }